import React from "react";
import { Outlet } from "react-router-dom";
import { AlumniAuthProvider } from "../../contexts/AlumniAuthContext";

const AlumniRoot = () => (
  <AlumniAuthProvider>
    <Outlet />
  </AlumniAuthProvider>
);

export default AlumniRoot;
